import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendProfileLinkService {

  constructor() { }
  private profile_link = new BehaviorSubject<String>(null);

  setProfileLink(profile_link: String) {
    this.profile_link.next(profile_link);
  }

  getProfileLink(): Observable<String> {
    return this.profile_link.asObservable();
  }
  resetProfileLink() {
    let temp = new BehaviorSubject<String>(null);
    this.profile_link = temp;

  }
}
